"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapShadeWithPrice = void 0;
var _productBox = require("@ori/product-box");
const mapShadeWithPrice = shade => {
  const {
    productCode,
    hexColors,
    imageUrl
  } = (0, _productBox.mapShade)(shade);
  return {
    showBackInStockNotification: shade.backInStockAvailability?.showBackInStockNotification ?? false,
    name: shade.shadeName ?? '',
    code: shade.productCode,
    shade: {
      productCode,
      hexColors,
      imageUrl,
      canBeSold: (0, _productBox.mapCanBeSold)(shade.labels),
      name: shade.shadeName
    },
    price: {
      currentFormatted: (0, _productBox.getCurrentFormattedPrice)({
        formattedPrice: shade.formattedPrice
      }),
      oldFormatted: (0, _productBox.getOldPrice)({
        formattedPrice: shade.formattedPrice
      })
    }
  };
};
exports.mapShadeWithPrice = mapShadeWithPrice;
